import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { instance } from '../../lib/axiosInstance'

export interface divisionsAndRegionsState {
  data:
    | {
        businessRegions: string[]
        businessRegionToDivisions:
          | Record<
              string,
              { code: string; name: string; businessRegion: string }[]
            >
          | undefined
        divisionCodes: Record<string, string> | undefined
        divisions: Record<string, string> | undefined
        divisionsSortedByValues: Record<string, string> | undefined
        regions: Record<string, string> | undefined
        regionsWithLabels: { label: string; value: string }[] | undefined
        regionToDivision: Record<string, Array<string>> | undefined
        regionToDivisionWithFullNames:
          | Record<
              string,
              { code: string; name: string; businessRegion: string }[]
            >
          | undefined
      }
    | undefined

  error: string | undefined
  loading: boolean | undefined
}

export const getDivisionAndRegionData = createAsyncThunk(
  'api/divisionAndRegionData',
  async () => {
    try {
      const response = await instance.get<divisionsAndRegionsState['data']>(
        'divisionAndRegionData'
      )
      sessionStorage.setItem(
        'divisionsAndRegions',
        JSON.stringify(response.data)
      )
      return response.data
    } catch (error) {
      throw Error('Failed to Fetch the Plans')
    }
  }
)
const initialState: divisionsAndRegionsState = {
  data: undefined,
  error: undefined,
  loading: undefined,
}

export const divisionsAndRegionsSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(getDivisionAndRegionData.pending, (state) => {
        state.loading = true
        state.error = undefined
      })
      .addCase(getDivisionAndRegionData.fulfilled, (state, action) => {
        state.data = action.payload
        state.loading = false
        state.error = undefined
      })
      .addCase(getDivisionAndRegionData.rejected, (state, action) => {
        state.data = undefined
        state.loading = false
        state.error =
          action.error.message || 'Failed to fetch regions and divisions Data'
      })
  },
  initialState,
  name: 'divisionsAndRegions',
  reducers: {},
})
